import React from "react";

var ClipPath = function ClipPath(props) {
  return React.createElement("defs", null, React.createElement("clipPath", {
    id: props.clipId
  }, props.children));
};

export default ClipPath;